// data store for temporary data, to be used and discarded while progressing through the app
import _ from 'lodash'

const state = {
    current_company: -1
}
const getters = {
    currentCompany: function (state, getters, rootState, rootGetters) {
        // return the company structure from company store based on stored ucid
        //let companies = rootGetters['company/companyDataFull']
        let companies = rootGetters['portfolio/portfolioAll'];
        return _.reduce(companies, (memo, data) => {
            if (data.ucid === state.current_company) return data
            return memo
        }, {})
    },
    currentPortfolioItems: (state, getters, rootState, rootGetters) => (ucid) => {
        let companies = rootGetters['portfolio/portfolioAll'];
        let currentPortfolioItems = companies.filter((data) => {
            if (data.ucid === Number(ucid)) {
                // if (data.user_investment_status != 'Invested') {
                let diligence = rootGetters["diligence/diligenceData"].filter(item => item.ucid == data.ucid)
                if (diligence && diligence[0] && diligence[0]._id) {
                    data.diligenceId = diligence[0]._id
                    data.deal_stage = diligence[0].deal_stage
                }
                return data
            }
        })
        return currentPortfolioItems[0];
    }
}

const mutations = {
    currentCompany(state, company) {
        state.current_company = company
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}